export default __webpack_public_path__ + "static/media/search.689e6ef3.svg";